import * as React from "react";
import { SVGProps, memo } from "react";
const SvgVirtualConnection = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    role="img"
    {...props}
  >
    <path
      fill="#666"
      fillRule="evenodd"
      d="M15 1a1 1 0 0 1 1 1v2a.995.995 0 0 1-.134.501A.982.982 0 0 1 16 5v2a.995.995 0 0 1-.134.501A.982.982 0 0 1 16 8v2a1 1 0 0 1-1 1H8v1.086c.436.154.778.502.924.941L8.914 13 14 13v1H8.914l.008-.022a1.5 1.5 0 0 1-2.796.124l-.04-.101L2 14v-1l4.086-.001-.01.028c.146-.439.489-.788.924-.942V11H1a1 1 0 0 1-1-1V8c0-.182.049-.353.134-.5A.993.993 0 0 1 0 7V5c0-.182.049-.353.134-.5A.993.993 0 0 1 0 4V2a1 1 0 0 1 1-1h14ZM7.5 13a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1ZM13 8H1v2h14V8h-1v1h-1V8Zm0-3H1v2h14V5h-1v1h-1V5Zm0-3H1v2h14V2h-1v1h-1V2Z"
    />
  </svg>
);
const Memo = memo(SvgVirtualConnection);
export default Memo;
